/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "When to use attrs?"
    }), "\n", _jsxs(_components.p, {
      children: ["You can pass in attributes to styled components using ", _jsx(_components.a, {
        href: "/docs/basics#attaching-additional-props",
        children: "attrs"
      }), ", but it is not always sensible to do so."]
    }), "\n", _jsxs(_components.p, {
      children: ["The rule of thumb is to use ", _jsx(_components.code, {
        children: "attrs"
      }), " when you want every instance of a styled component to have that prop, and ", _jsx(_components.a, {
        href: "/docs/basics#passed-props",
        children: "pass props"
      }), " directly when every instance needs a different one:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const PasswordInput = styled.input.attrs(props => ({\n  // Every <PasswordInput /> should be type=\"password\"\n  type: \"password\"\n}))``\n\n// This specific one is hidden, so let's set aria-hidden\n<PasswordInput aria-hidden=\"true\" />\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The same goes for props that can be inferred based on the \"mode\" of another prop. In this case you can set a property on ", _jsx(_components.code, {
        children: "attrs"
      }), " to a function that computes that prop based on other props."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
